module.exports = __webpack_public_path__ + "static/media/dheta-1.539172bb.jpg";